import { Map, List, fromJS } from 'immutable';
import { get } from 'lodash';

import {
  SIMILAR_PACKAGES_FAIL,
  SIMILAR_PACKAGES_START,
  SIMILAR_PACKAGES_CREATED_REQUEST,
  SIMILAR_PACKAGES_FINISH,
  SIMILAR_PACKAGES_STATE,
  SIMILAR_PACKAGES_POPUP_OPENED,
  SIMILAR_PACKAGES_POPUP_CLOSED,
  CREATE_PACKAGE,
  CREATE_PACKAGE_FAIL,
  CLEAR_SEARCH,
  SET_SEARCHER_DATE,
  SET_ADULTS,
  SET_KIDS,
  SET_NIGHTS,
} from '../constants/similar-packages';
import { ACTUALIZE_PACKAGE_FAIL } from '../constants/actualization';

const initialState = fromJS({
  state: SIMILAR_PACKAGES_STATE.INITIAL,
  tours: List(),
  adjust: Map(),
  failed: false,
  excludeCurrentOperator: null,
  isPopupOpened: false,
  newRequestId: null,
});

const setAdjust = (field, state, payload) => {
  const adjust = state.get('adjust');

  return state.merge(
    fromJS({
      state: SIMILAR_PACKAGES_STATE.PREPARE,
      adjust: adjust.merge(
        fromJS({
          [field]: payload,
        }),
      ),
    }),
  );
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SIMILAR_PACKAGES_START:
      return state.set('state', SIMILAR_PACKAGES_STATE.PERFORMING);
    case SIMILAR_PACKAGES_CREATED_REQUEST:
      return state.set('newRequestId', payload);
    case SIMILAR_PACKAGES_POPUP_OPENED:
      return state.set('isPopupOpened', true);
    case SIMILAR_PACKAGES_POPUP_CLOSED:
      return state.set('isPopupOpened', false);
    case SIMILAR_PACKAGES_FINISH: {
      const {
        state: status,
        tours,
        hotel_offers_count: hotelOffersCount,
      } = payload;
      return state.merge(
        fromJS({
          state: status,
          tours,
          hotelOffersCount,
        }),
      );
    }
    case SIMILAR_PACKAGES_FAIL:
      return state.merge(
        fromJS({
          failed: true,
          state: SIMILAR_PACKAGES_STATE.NO_RESULTS,
        }),
      );
    case ACTUALIZE_PACKAGE_FAIL: {
      const defaultValue = true;
      const excludeCurrentOperator = get(
        payload,
        'exclude_operator',
        defaultValue,
      );
      return state.set('excludeCurrentOperator', excludeCurrentOperator);
    }

    // CREATE
    case CREATE_PACKAGE:
      return state.set('state', SIMILAR_PACKAGES_STATE.REDIRECT);
    case CREATE_PACKAGE_FAIL:
      return state.merge(
        fromJS({
          state: SIMILAR_PACKAGES_STATE.NO_RESULTS,
          failed: true,
        }),
      );

    // SEARCHER/ADJUST
    case SET_SEARCHER_DATE: {
      return setAdjust('date', state, payload);
    }
    case SET_ADULTS:
      return setAdjust('adults', state, payload);
    case SET_KIDS:
      return setAdjust('kidsAges', state, payload);
    case SET_NIGHTS:
      return setAdjust('nights', state, payload);
    case CLEAR_SEARCH:
      return initialState;

    default:
      return state;
  }
}
